import BudgetPeriod from 'src/components/BudgetPeriod';
import { GridColumn } from 'src/components/GridWrapper';
import useActionRequiredInvoices from 'src/hooks/useActionRequiredInvoices';
import ActionRequiredAmountField from 'src/sections/action_required_invoices/ActionRequiredAmountField';
import GLCodeField from 'src/sections/action_required_invoices/glSummaryColumns/GLCodeField';

export const useSinglePeriodGLSummaryColumns = (): GridColumn<any>[] => {
  const { usesBudgets } = useActionRequiredInvoices();

  return [
    {
      field: 'glCd',
      title: 'GL code',
      menu: false,
      component: GLCodeField,
      width: 120,
      minResizableWidth: 100,
    },
    {
      field: 'description',
      title: 'Description',
      menu: false,
      width: 250,
      minResizableWidth: 200,
    },
    {
      field: 'accountingPeriod',
      title: 'Accounting Period',
      menu: false,
      className: 'text-center',
      width: 120,
      component: BudgetPeriod,
      headerClassName: 'text-center',
      minResizableWidth: 100,
    },
    {
      field: 'poGlTotal',
      title: 'PO GL Total',
      menu: false,
      format: '{0:c2}',
      component: ActionRequiredAmountField,
      width: 120,
      headerClassName: 'text-center',
      minResizableWidth: 100,
    },
    {
      field: 'currentDocGlTotal',
      title: 'Current Doc GL Total',
      menu: false,
      format: '{0:c2}',
      component: ActionRequiredAmountField,
      width: 150,
      headerClassName: 'text-center',
      minResizableWidth: 100,
    },
    {
      field: 'otherDocGlTotal',
      title: 'Other Doc GL Total for PO',
      menu: false,
      format: '{0:c2}',
      component: ActionRequiredAmountField,
      width: 150,
      headerClassName: 'text-center',
      minResizableWidth: 100,
    },
    {
      field: 'glRemainingBudget',
      title: 'Current Forecast Remaining Balance',
      menu: false,
      format: '{0:c2}',
      component: ActionRequiredAmountField,
      headerClassName: 'text-center',
      width: 150,
      minResizableWidth: 100,
    },
    ...(usesBudgets
      ? ([
          {
            field: 'glRemainingInitialBudget',
            title: 'Current Budget Remaining Balance',
            dataType: 'dollar',
            format: '{0:c2}',
            menu: false,
            component: ActionRequiredAmountField,
            width: 150,
            minResizableWidth: 100,
          },
        ] as const)
      : []),
  ];
};
